/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var jove__app__validation__model__SortByColumnEnum;

(function (jove__app__validation__model__SortByColumnEnum) {
  jove__app__validation__model__SortByColumnEnum["CREATED"] = "created";
  jove__app__validation__model__SortByColumnEnum["UPDATED"] = "updated";
  jove__app__validation__model__SortByColumnEnum["CANDIDATE_NAME"] = "candidate_name";
  jove__app__validation__model__SortByColumnEnum["ASSIGNEE_NAME"] = "assignee_name";
  jove__app__validation__model__SortByColumnEnum["ORGANIZATION_NAME"] = "organization_name";
  jove__app__validation__model__SortByColumnEnum["CREATED_AT"] = "created_at";
  jove__app__validation__model__SortByColumnEnum["CONTRACT_START_DATE"] = "contract_start_date";
})(jove__app__validation__model__SortByColumnEnum || (jove__app__validation__model__SortByColumnEnum = {}));